import { render } from 'preact';
import { Prefs, stringsFor } from './app/prefs';
import { App } from './ui/app';

function supported(): boolean {
  try {
    return !!(window.crypto?.subtle && typeof BigInt === 'function' && window.localStorage && Intl.RelativeTimeFormat && window.isSecureContext);
  } catch {
    return false;
  }
}

const root = document.getElementById('app')!;

if (!supported()) {
  root.textContent = stringsFor(Prefs.currentLanguage()).unsupportedBrowser;
  root.className = 'unsupported';
} else {
  root.textContent = '';
  render(<App />, root);

  // App feel on iPhone: no pinch or double-tap zoom (Safari gesture events).
  for (const ev of ['gesturestart', 'gesturechange', 'gestureend']) {
    document.addEventListener(ev, (e) => e.preventDefault(), { passive: false });
  }

  // Ask the browser to keep COINWOW's data (reduces automatic deletion).
  navigator.storage?.persist?.().catch(() => {});

  // Offline shell (the API itself is never cached).
  if ('serviceWorker' in navigator && location.protocol === 'https:') {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  }
}
